import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { UserService } from '../services/user.service';

@Component({ templateUrl: 'register.component.html', styleUrls: ['./register.component.scss'] })
export class RegisterComponent implements OnInit {
    form!: FormGroup;
    loading = false;
    submitted = false;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService
    ) { }

    ngOnInit() {
        this.form = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', Validators.required],
            password: ['', [Validators.required, Validators.minLength(8)]]
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;


        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        let user = {
            FirstName: this.f.firstName.value,
            LastName: this.f.lastName.value,
            Email: this.f.email.value,
            Password: this.f.password.value,
        };
        this.userService.signup(user)
            .pipe(first())
            .subscribe({
                next: () => {
                    alert('Registration successful');
                    this.router.navigate(['../login'], { relativeTo: this.route });
                },
                error: (error:any) => {
                    alert(error);
                    this.loading = false;
                }
            });
    }
}